import { useMutation, useQuery } from 'react-query';
import axios from 'axios';
import apis from '../config';
import { useState } from 'react';
import { toast } from 'react-toastify';

const useUpdateDetails = ({ hash, setLoading }) => {
  const [detailsToUpdate, setDetailsToUpdate] = useState([]);

  const { data } = useQuery(['initDetails'], async () => {
    const formData = new FormData();
    formData.append('mode', 'getUpdateDetails');
    formData.append('hash', hash);

    const output = await axios.post(apis.STUDENTS_API, formData);

    if (output.data.response.status === 'OK') {
      setDetailsToUpdate(output.data.response.student);
    }

    return output.data.response;
  });

  const mutate = useMutation(async () => {
    const formData = new FormData();
    formData.append('mode', 'selfUpdate');
    formData.append('student_email', detailsToUpdate.student_email);
    formData.append('student_school', detailsToUpdate.student_school);
    formData.append(
      'student_school_level',
      detailsToUpdate.student_school_level
    );
    formData.append('student_mobile', detailsToUpdate.student_mobile);
    formData.append(
      'student_address_postal',
      detailsToUpdate.student_address_postal
    );
    formData.append(
      'student_preferred_session_time',
      detailsToUpdate.student_preferred_session_time
    );
    formData.append('hash', hash);

    const output = await axios.post(apis.STUDENTS_API, formData);
    setLoading(false);
    toast.success('Details saved. You may now close this window', {
      position: toast.POSITION.BOTTOM_LEFT,
    });
  });

  const handleFormUpdate = e => {
    console.log(e.target.value);
    setDetailsToUpdate(prev => ({ ...prev, [e.target.name]: e.target.value }));
    console.log(detailsToUpdate);
  };

  const formSubmit = () => {
    mutate.mutate();
    setLoading(true);
  };

  return { data, detailsToUpdate, handleFormUpdate, formSubmit };
};

export default useUpdateDetails;
